import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { TipoDelegadoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class TipoDelegadoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getTipoDelegadoService(): Observable<BodyListResponse<TipoDelegadoDTO>> {
    return this.http.get<BodyListResponse<TipoDelegadoDTO>>(API_URL + '/api/v1/tipoDelegado/todos');
  }

  guardarTipoDelegadoService(tipoDelegadoDTO: TipoDelegadoDTO): Observable<BodyResponse<TipoDelegadoDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/tipoDelegado', tipoDelegadoDTO);
  }

  getTipoDelegadoPorCodigoService(codigo: string): Observable<BodyResponse<TipoDelegadoDTO>> {
    return this.http.get<BodyResponse<TipoDelegadoDTO>>(API_URL + '/api/v1/tipoDelegado/' + codigo);
  }
}
